const _initialState = {
    serviceRequestsList: [],
    defaultServiceRequest: null,
    fetching: false,
    fetched: false,
    error: null,
};

export default function serviceRequestReducer(state = _initialState, action) {
    switch (action.type) {
    case "FETCH_SERVICE_REQUESTS":
        return {...state, fetching: true}

    case "FETCH_SERVICE_REQUESTS_REJECTED":
        return {...state, fetching: false, error: action.payload};

    case "FETCH_SERVICE_REQUESTS_FULFILLED":
        return {
            ...state,
            fetching: false,
            fetched: true,
            serviceRequestsList: action.payload
        };

    case "FETCH_DEFAULT_SR_FULFILLED":
        return {
            ...state,
            fetching: false,
            defaultServiceRequest: action.payload
        }

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./app/reducers/timeInput/serviceRequests.js